module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp1_7005.302e5263.png";